/* ==========================================================================
  ajax.js
========================================================================== */

function getActiveMovieListType() {
  var activeType = 'movies';
  var types = document.querySelectorAll('.js-all-movies-list-type');
  for (var i = 0; i < types.length; i++) {
    if (types[i].classList.contains('is-active')) {
      activeType = types[i].getAttribute('data-type');
    }
  }
  return activeType;
}

jQuery(document).ready(function($){
	var data = {
		'action': 'br_movies_handler',
		'genre': '-1',
		'date': '-1',
		'format': '-1',
		'language': '-1',
    'activeType': getActiveMovieListType()
	};

  // take genre from current url
  var url = new URL(window.location.href);

  var genre = url.searchParams.get('genre');
  if (genre) {
    data.genre = genre;
  }

  var date = url.searchParams.get('date');
  if (date) {
    data.date = date;
  }

  var format = url.searchParams.get('format');
  if (format) {
    data.format = format;
  }

  var language = url.searchParams.get('language');
  if (language) {
    data.language = language;
  }


	ajax_call(data);

  var filter_movies = function() {

		var genre = $( '#genreselect option:selected' ).val();

    // update url parameter
    var url = new URL(window.location.href);
    if (genre && genre !== '-1') {
      url.searchParams.set('genre', genre);
    } else {
      url.searchParams.delete('genre');
    }

		var date = $( '#dayselect option:selected' ).val();
    if (date && date !== '-1') {
      url.searchParams.set('date', date);
    } else {
      url.searchParams.delete('date');
    }

		var format = $( '#formatselect option:selected' ).val();
    if (format && format !== '-1') {
      url.searchParams.set('format', format);
    } else {
      url.searchParams.delete('format');
    }

		var language = $( '#languageselect option:selected' ).val();
    if (language && language !== '-1') {
      url.searchParams.set('language', language);
    } else {
      url.searchParams.delete('language');
    }
    window.history.replaceState(null, null, url);

    var activeAlternativeTheater = null;
    var activeAlternativeTheaterTitle = null;
    var active_alternative_theater_button = document.querySelector('.js-all-movies-local-button.is-active');
    if (active_alternative_theater_button) {
      activeAlternativeTheater = active_alternative_theater_button.getAttribute('data-slug');
      activeAlternativeTheaterTitle = active_alternative_theater_button.textContent;
    }

    // console.log('genre', genre);
    // console.log('date', date);
    // console.log('format', format);
    // console.log('language', language);

		data = {
			'action': 'br_movies_handler',
			'genre': genre,
			'date': date,
			'format': format,
      'language': language,
      'activeAlternativeTheater': activeAlternativeTheater,
      'activeAlternativeTheaterTitle': activeAlternativeTheaterTitle,
      'activeType': getActiveMovieListType()
		};
		ajax_call(data);
  };

	$( "#dayselect, #genreselect, #formatselect, #languageselect" ).on( "change", function() {
    filter_movies();
	});

  var type_buttons = document.querySelectorAll('.js-all-movies-list-type');
  for (var i = 0; i < type_buttons.length; i++) {
    type_buttons[i].addEventListener('click', function(e) {
      e.preventDefault();
        var buttons = document.querySelectorAll('.js-all-movies-list-type');
        for (var j = 0; j < buttons.length; j++) {
          buttons[j].classList.remove('is-active');
        }
        e.currentTarget.classList.add('is-active');

        // change history to match href
        var href = e.currentTarget.getAttribute('href');
        history.pushState(null, null, href);

        filter_movies();
    });
  }


  var filter_alternative_theater_buttons = document.querySelectorAll('.js-all-movies-local-button');
  for (var i = 0; i < filter_alternative_theater_buttons.length; i++) {
    filter_alternative_theater_buttons[i].addEventListener('click', function(e) {

      var buttons = document.querySelectorAll('.js-all-movies-local-button');
      for (var j = 0; j < buttons.length; j++) {
        buttons[j].classList.remove('is-active');
      }
      e.currentTarget.classList.add('is-active');
      filter_movies();

    });
  }

	function ajax_call(data) {

    var activeAlternativeTheaterParam = '';
    if (data.activeAlternativeTheater) {
      activeAlternativeTheaterParam = '&f_cinemas=' + data.activeAlternativeTheater;
    }

    if (data.activeAlternativeTheaterTitle) {
      var titleEl = document.querySelector('.js-all-movies-title');
      if (titleEl) {
        titleEl.textContent = data.activeAlternativeTheaterTitle;
      }
    }

		$.ajax({
			url : movies_js.ajaxurl + '?lang=' + movies_js.lang + activeAlternativeTheaterParam,
			data : data,
			type : 'POST',
			beforeSend : function ( xhr ) {
				$('#movie-response').html( '<div class="container-fluid paivitys paivitys-elokuvat v-center"> <div class="row justify-content-center align-center mx-auto"> <div class="col-md-8 text-center"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="80px" height="80px" viewBox="0 0 24 24" style="enable-background:new 0 0 50 50;" xml:space="preserve"> <rect x="0" y="0" width="4" height="7" fill="#CD9842"> <animateTransform attributeType="xml" attributeName="transform" type="scale" values="1,1; 1,3; 1,1" begin="0s" dur="0.6s" repeatCount="indefinite"/> </rect> <rect x="10" y="0" width="4" height="7" fill="#163D71"> <animateTransform attributeType="xml" attributeName="transform" type="scale" values="1,1; 1,3; 1,1" begin="0.2s" dur="0.6s" repeatCount="indefinite"/> </rect> <rect x="20" y="0" width="4" height="7" fill="#CD9842"> <animateTransform attributeType="xml" attributeName="transform" type="scale" values="1,1; 1,3; 1,1" begin="0.4s" dur="0.6s" repeatCount="indefinite"/> </rect> </svg> </div></div></div>' );
				$('#genreselect').attr( 'disabled', 'disabled' );
				$('#dayselect').attr( 'disabled', 'disabled' );
				$('#formatselect').attr( 'disabled', 'disabled' );
				$('#languageselect').attr( 'disabled', 'disabled' );

			},
			success : function( response ) {
				console.log(response);
				if ( response.posts !== '' ) {
					$('#movie-response').html( response.posts );
					$('#genreselect').removeAttr('disabled');
					$('#dayselect').removeAttr('disabled');
					$('#formatselect').removeAttr('disabled');
					$('#languageselect').removeAttr('disabled');
          // hook into dataLayer event etc.
          var readyEvent = new CustomEvent( 'BioRexMovieAjaxReady' );
          window.dispatchEvent(readyEvent);
				} else {
					$('#movie-response').html( '<div class="container-fluid paivitys paivitys-elokuvat"> <div class="row justify-content-center align-center mx-auto"> <div role="status" class="col-md-8 text-center pt-5"> <h4 style="color:#6c757d;">Valituilla tiedoilla ei löytynyt yhtään näytöstä.</h4></div></div></div>' );
				}
			}
		});
	}

});
